/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import { connect } from 'react-redux';
import {} from '../../actions/actions';
import { withRouter } from 'react-router-dom';
import TcBreadcrumb from './tc.breadcrumb.component';
import TcBreadcrumbService from './tc.breadcrumb.service';
import flows from './tc.breadcrumb.config';

export const mapStateToProps = (state, ownProps) => {
  return {
    //ownProps.flows used to inject different flows when testing
    flows: ownProps.flows || flows
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    /**
     * @description filter in the breadcrumb paths defined in a flow and when a path
     * pattern matches the url then return the items from flow below the index of the
     * matched path including the found one.
     *
     * @param flows
     * @param location
     */
    buildPaths(flows, location) {
      const url = location.pathname,
        state = location.state ? location.state.forBreadcrumb : null,
        flowsKeys = Object.keys(flows);

      let i = 0,
        paths = [],
        flowKey = flowsKeys[i];

      while (flowKey) {
        const breadcrumbFlow = flows[flowKey];

        let matches = breadcrumbFlow.filter((item) => {
          return TcBreadcrumbService.testPattern(item.patterns, url);
        });

        if (matches.length > 0) {
          paths = breadcrumbFlow.slice(0, matches[0].index);
          break;
        }
        flowKey = flowsKeys[i++];
      }

      return paths.map((path) => {
        path.state = state;
        return path;
      });
    }
  };
};

const TcBreadcrumbContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(TcBreadcrumb));

export default TcBreadcrumbContainer;
